import logo from './jensen-het-vrije-geluid.png'
// import ad from './steun-jensen-ad.png'
import ad from './support-het-vrije-geluid.png'
import petjeAf from './petjeaf.png'
import jensenShowLogo from './jensen-show-logo.png'
import FountainIcon from './fountain-share-icon.png'
import PodverseIcon from './podverse-share-icon.png'

export { logo, ad, petjeAf, jensenShowLogo, FountainIcon, PodverseIcon }
